import * as React from 'react'

const SvgCopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 6.25V17.5H6.25V6.25H17.5zm0-1.25H6.25C5.56 5 5 5.56 5 6.25V17.5c0 .69.56 1.25 1.25 1.25H17.5c.69 0 1.25-.56 1.25-1.25V6.25c0-.69-.56-1.25-1.25-1.25zm-15 6.25H1.25V2.5c0-.69.56-1.25 1.25-1.25h8.75V2.5H2.5v8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCopyIcon
